module.exports = __webpack_public_path__ + "media/logos/primary_light-e219e59e.png";